import { Link, Navigate, Route, Routes, useNavigate } from 'react-router-dom';

import { CustomerContextProvider } from './contexts/CustomerContext';
import customerLogo from './customer/Disney/customerLogo.png';
import AddressPage from './pages/AddressPage';
import EnrollmentLandingPage from './pages/EnrollmentLandingPage';
import ReservationFlightDetails from './pages/ReservationFlightDetails';
import ReservationConfirmationPage from './pages/ReservationConfirmationPage';
import BagEventsPage from './pages/BagEventsPage';
import ModifyFlightDetailsPage from './pages/ModifyFlightDetailsPage';
import ModifyContactDetailsPage from './pages/ModifyContactDetailsPage';
import CancelEnrollmentPage from './pages/CancelEnrollmentPage';
import EnrollmentRequestPage from './pages/EnrollmentRequestPage';

import './customer/Disney/i18n';
import './customerStyles/disney.css';
import './styles/micrositeIcons.css';
import Footer from './components/Footer';

function AppRouter() {
    const navigate = useNavigate();

    return (
        <CustomerContextProvider logo={customerLogo}>
            <div className="app-wrapper">
                <div className="app-wrapper__header">
                    <Link to="/">
                        <img
                            alt="logo"
                            className="app-wrapper__logo"
                            src={customerLogo}
                        />
                    </Link>
                </div>
                <Routes>
                    <Route path="/waltdisneyworld">
                        <Route path="" element={<EnrollmentLandingPage />} />
                        <Route
                            path="enrollmentRequest"
                            element={<EnrollmentRequestPage />}
                        >
                            <Route
                                path=":enrollmentRequestId"
                                element={<EnrollmentRequestPage />}
                            />
                            <Route
                                path=":enrollmentRequestId/edit/*"
                                element={<EnrollmentRequestPage />}
                            />
                        </Route>
                        <Route path=":reservationId/:reservationLastName">
                            <Route
                                path="reservationFlightDetails"
                                element={<ReservationFlightDetails />}
                            />

                            <Route
                                path="reservationAddressDetails"
                                element={<AddressPage />}
                            />
                            <Route
                                path=""
                                element={<ReservationConfirmationPage />}
                            />
                            <Route
                                path="modifyFlightDetails"
                                element={<ModifyFlightDetailsPage />}
                            />
                            <Route
                                path="modifyContactDetails"
                                element={<ModifyContactDetailsPage />}
                            />
                            <Route
                                path="bagEvents"
                                element={<BagEventsPage />}
                            />
                            {/* <Route
                                path="cancelEnrollment"
                                element={<CancelEnrollmentPage />}
                            /> */}
                        </Route>
                    </Route>
                    <Route
                        path="*"
                        element={<Navigate to="/waltdisneyworld" />}
                    />
                </Routes>
                <Footer />
            </div>
        </CustomerContextProvider>
    );
}

export default AppRouter;
